/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.assetLibraryModule')
  .directive('bulbAssetLibrarySelectionModal', [
    '$timeout',
    'BulbAuthService',
    'BulbBrowserService',
    bulbAssetLibrarySelectionModal,
  ]);

function bulbAssetLibrarySelectionModal($timeout, BulbAuthService, BulbBrowserService) {
  return {
    restrict: 'E',
    transclude: true,
    template: '<div><ng-transclude /></div>',
    link: function(scope, element) {

      // To set the active tab
      scope.activeTab = {};
      // value to detemine if the user can see the unsplash tab 
      scope.isUnsplashAvailable = BulbAuthService.currentUser.features.UnsplashRestrictionFeature.value !== 'DISABLED';

      /*
       * Handle the key press event if enter is pressed
       * then set Active Tab and call event handlers
       * @param keyEvent
       * @param tabName
       */
      scope.setTabOnKeyPress = function(keyEvent, tabName) {
        if (keyEvent.which === 13) {
          scope.setActiveTabAndHandler(tabName);
        }
      };

      /**
       * Set the active tab
       * and if the tabName is GOOGLE_DRIVE, ONE_DRIVE or UNSPLASH
       * then call their event handler respectively.
       * @param tabName
       */
      scope.setActiveTabAndHandler = function(tabName) {
        scope.activeTab = {};
        scope.activeTab[tabName] = true;
        if (tabName === 'GOOGLE_DRIVE') {
          scope.importGoogleDriveItemHandler();
        } else if (tabName === 'ONE_DRIVE') {
          scope.importOneDriveItemHandler();
        } else if (tabName === 'UNSPLASH') {
          scope.unsplashPhotoHandler();
        }
      };

      // Boolean to check if our app is running as a hosted webapp, PWA.
      scope.runningInPWAEnvironment = BulbBrowserService.isPWAEnvironment();

      var modal = $(element).closest('.reveal-modal').eq(0);

      var containers = null;
      var contents = null;
      var container = null;
      var modalBodies = null;
      var modalBody = null;
      var tabContents = null;
      var init = false;
      var containerPositionTop  = 145;

      var updateScrollBars = function(refreshScrollTop) {
        if(!init) {
          return;
        }

        if (refreshScrollTop) {
          contents.scrollTop(0);
        }

        $timeout(function() {
          for (var i = 0; i < contents.length; i++) {
            window.Ps.update(contents.eq(i).get(0));
          }
        }, 1);
      };

      var initContents = function() {
        contents = $(element).find('.bulb-assetlibrary-entry-scroll-content');
      };

      var updateLayout = function(event, refreshScrollTop) {

        if (!init) {
          containers = $(element).find('.bulb-assetlibrary-entry-container');
          container = containers.eq(0);
          initContents();

          modalBodies = $('.bulb-asset-library-selection-modal-body');
          modalBody = modalBodies.eq(0);
          tabContents = modal.find('.tabs-content');

          // for FireFox
          if (!container.offset() || !container.get(0)) {
            $timeout(updateLayout, 100);
            return;
          }

          init = true;
        }

        /* jshint camelcase: false */
        if (Foundation.utils.is_medium_up()) {
          var modalHeight = modal.height();

          var titleAndTabHeight = modal.find('.tabs-content').eq(0).position()?.top || 0;
          var tabContentHeight = modalHeight - titleAndTabHeight;
          var containerBottomMargin = 20;

          containers.height(tabContentHeight - containerPositionTop - containerBottomMargin);
        } else {
          containers.height('auto');
        }

        updateScrollBars(false);
      };

      $(window).resize(updateLayout);

      scope.$on('$destroy', function() {
        $(window).unbind('resize', updateLayout);
      });

      scope.$watch(function() {
        return $(element).is(':hidden');
      }, function(hidden) {
        if (!hidden) {
          updateLayout();
        }
      });

      $timeout(updateLayout, 1);

      scope.$on('viewChanged', function() {
        initContents();
      });

      scope.$on('listUpdated', function() {
        updateScrollBars(true);
      });
    }
  };
}
